export interface AppConfig {
  OIDC_CONFIGURATION: unknown;
}

export interface QueryParams {
  [key: string]: string | number | boolean | undefined;
}

export interface Country {
  countryCode: string;
  countryName: string;
  countryCodeISO?: string;
  isDestination?: boolean;
  countryApiKey?: string;
}

export interface IBusinessUnit {
  businessUnitId?: number;
  businessUnitName?: string;
  isActive?: boolean;
}

export interface State {
  stateId: number;
  stateName: string;
  countryCode: string;
}

export interface IReferenceData {
  code: string;
  description: string;
}

export enum AddressType {
  WORK = 'WORK',
}

export enum DependentRelationship {
  Spouse = 'SPOUSE',
  Child = 'CHILD',
}

export enum Relationship {
  Principal = 'Principal',
  Dependent = 'Dependent',
  Child = 'Child',
  Spouse = 'Spouse',
}

export interface FormEntity {
  docName: string;
  docTypeId: string;
  userTypes: string[];
  roles: string[];
  caseId?: string;
  docId?: string;
  fields?: any;
  beneId?: string;
  companyId?: string;
  clientCaseIds?: string;
  immigration?: any;
  [key: string]: any;
}

export interface IInstanceConfig {
  instanceConfigID: number;
  showAdminNews: boolean;
  isGCPToggleOn: boolean;
  immigrationInstance: number;
  enableO365SiteLibrary: boolean;
  numberingScheme: number;
  isEBillBillingBrokerEventEnabled: boolean;
  shouldSanitizeDataSentToBillingBroker: boolean;
  shouldMarkAderantClientUnoAsSet: boolean;
  rpaNotificationEmailFrom: string;
  rpaNotificationEmailTo: string;
}

export interface IImmigrationProviderMetaData {
  companyImmigrationProviderId: number;
  immigrationProviderFirmId: number;
  companyId: number;
  isPrimary: boolean;
  defaultSenderEmailDomain: string;
  defaultRecipientEmailDomain: string;
  providerName: string;
}
